/**
 * When the map instance needs to be communicated across components.
 * Cleared on component exit.
 */
import {makeVar} from "@apollo/client";

export const mapInternals = makeVar(null);